import React from 'react';
import {
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack, FDTooltip,
} from '@facet-wealth/design';
import { dataAttrs, testAttr } from 'Helpers/Testing';

export const PathSelectors = ({ paths, selectedPath, setSelectedPath }) => {
  return (
    <FDStack direction={'row'} spacing={1}>
      {paths.map((path) => {
        if (path.id() === selectedPath) {
          // Use a highlighted button for the selected path
          const btn = (
            <FDPrimaryActionButton
              label={path.attr('name')}
              {...dataAttrs(
                'roadmap-explorer-path-selector-btn',
                path,
                {
                  [testAttr.dataActive]: true,
                  [testAttr.dataTitle]: path.attr('name'),
                },
              )}
              size="sm"
            />
          );
          return path.attr('description') ? <FDTooltip title={path.attr('description')}>{btn}</FDTooltip> : btn;
        }

        const btn = (
          <FDSecondaryActionButton
            label={path.attr('name')}
            onClick={() => setSelectedPath(path.id())}
            {...dataAttrs(
              'roadmap-explorer-path-selector-btn',
              path,
              {
                [testAttr.dataActive]: false,
                [testAttr.dataTitle]: path.attr('name'),
              },
            )}
            icon="circle"
            iconColor={path.attr('color')}
            iconPosition="start"
            size="sm"
          />
        );
        return path.attr('description') ? <FDTooltip title={path.attr('description')}>{btn}</FDTooltip> : btn;
      })}
    </FDStack>
  );
};
PathSelectors.propTypes = {};
